tindie.product_search = (function(t, $) {
	var products = tindie.productUtils;
	var sendImpressions = function() {
		if (window.ga && ga.create) {
			ga('send', 'event', 'Search Page', 'Send Product Impressions', {
				nonInteraction: true,
				transport: 'beacon'
			});
		}
	}
	var ProductSearch = function() {
		var self = this;
		tindie.app.base.call(self);
		self.productList = ko.observableArray();
		self.createProductCard = function() {
			return products.createProductCard('Search Results Page', self.productList);
		}
		if (window.fbq) {
			//fbq('track', 'Search');
		}
	};
	t.init = function() {
		var vm = new ProductSearch();
		ko.applyBindings(vm, document.body);
		window.addEventListener('beforeunload', sendImpressions, false);
		$('#product-list-sort-by').on('change', function(ev) {
			$('#product-list-sort').submit();
		});
	}
	return t;
})(tindie.product_search || {}, jQuery);